import { Modal, List, Button, Typography, Empty } from 'antd'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useStore } from 'src/hooks'

const { Text } = Typography

type Props = {
   visible: boolean
   onClose: () => void
   onSubmit: (promotion: any | null) => void
   selectedDefault?: any | null
}

const SelectPromotionModal = ({ visible, onClose, onSubmit, selectedDefault = null }: Props) => {
   const OrderStore = useStore('OrderStore')
   const [loading, setLoading] = useState(false)
   const [promotions, setPromotions] = useState<any[]>([])
   const [selectedPromotion, setSelectedPromotion] = useState<any | null>(selectedDefault)

   useEffect(() => {
      if (visible) {
         fetchPromotions()
         setSelectedPromotion(selectedDefault || null)
      }
   }, [visible])

   const fetchPromotions = async () => {
      setLoading(true)
      try {
         const res = await OrderStore.getPromotions()
         setPromotions(res?.rows || [])
      } finally {
         setLoading(false)
      }
   }

   const handleApply = () => {
      onSubmit(selectedPromotion)
      onClose()
   }

   return (
      <Modal visible={visible} onCancel={onClose} footer={null} title="Mã khuyến mại" width={520}>
         {promotions.length === 0 ? (
            <Empty description="Không có mã khuyến mại" />
         ) : (
            <List
               loading={loading}
               dataSource={promotions}
               renderItem={(item) => {
                  const checked = selectedPromotion?.id === item.id

                  return (
                     <List.Item
                        onClick={() => {
                           if (checked) {
                              setSelectedPromotion(null)
                           } else {
                              setSelectedPromotion(item)
                           }
                        }}
                        style={{
                           cursor: 'pointer',
                           background: checked ? '#faf5e650' : '#fff',
                           borderRadius: 8,
                           padding: 12,
                           marginBottom: 8,
                           border: checked ? '1px solid #EDBB1D' : '1px solid #f0f0f0'
                        }}
                     >
                        <div style={{ flex: 1 }}>
                           <Text strong style={{ fontSize: 16 }}>
                              {item?.code}
                           </Text>
                           <div>
                              <Text type="secondary" style={{ fontSize: 12 }}>
                                 {item?.description}
                              </Text>
                           </div>
                           <div>
                              <Text type="secondary" style={{ fontSize: 12 }}>
                                 Hạn sử dụng: {moment(item?.endDate).format('HH:mm DD/MM/YYYY')}
                              </Text>
                           </div>
                        </div>

                        <div
                           style={{
                              width: 20,
                              height: 20,
                              borderRadius: '50%',
                              border: '1.5px solid #EDBB1D',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                           }}
                        >
                           {checked && (
                              <span
                                 style={{
                                    color: '#EDBB1D',
                                    fontSize: 16,
                                    fontWeight: 700
                                 }}
                              >
                                 ✓
                              </span>
                           )}
                        </div>
                     </List.Item>
                  )
               }}
            />
         )}

         <Button
            block
            type="primary"
            disabled={promotions.length === 0}
            onClick={handleApply}
            style={{ marginTop: 16 }}
         >
            Áp dụng
         </Button>
      </Modal>
   )
}

export default SelectPromotionModal
